// Busca fuzzy da command palette: subsequencia com bonus para inicio de
// palavra e letras seguidas. Ignora caixa e acentos. Pura e testada.

/** Minusculas sem acento ("Promoções" -> "promocoes"). */
export function foldText(text: string): string {
  return text.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
}

const WORD_START_BONUS = 8;
const CONSECUTIVE_BONUS = 5;
const MATCH_POINT = 1;

/** Pontua a consulta contra o texto. null = nao casa. Consulta vazia casa com 0. */
export function fuzzyScore(query: string, text: string): number | null {
  const q = foldText(query.trim());
  if (q === "") return 0;
  const t = foldText(text);
  let score = 0;
  let from = 0;
  let previous = -2;
  for (const char of q) {
    if (char === " ") continue;
    const index = t.indexOf(char, from);
    if (index === -1) return null;
    score += MATCH_POINT;
    if (index === 0 || t[index - 1] === " ") score += WORD_START_BONUS;
    if (index === previous + 1) score += CONSECUTIVE_BONUS;
    previous = index;
    from = index + 1;
  }
  // Textos mais curtos ganham um pouco no empate.
  return score - t.length * 0.01;
}

/** Filtra e ordena itens pela melhor pontuacao entre os campos pesquisaveis. */
export function fuzzyFilter<T>(items: readonly T[], query: string, fields: (item: T) => readonly string[]): T[] {
  return items
    .map((item, order) => {
      const scores = fields(item).map((f) => fuzzyScore(query, f)).filter((s): s is number => s !== null);
      return { item, order, score: scores.length > 0 ? Math.max(...scores) : null };
    })
    .filter((entry): entry is { item: T; order: number; score: number } => entry.score !== null)
    .sort((a, b) => b.score - a.score || a.order - b.order)
    .map((entry) => entry.item);
}
